import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaLicitantes from '../../components/contratos/licitantes';


function ListaLicitantesScreen() {
    return (
        <Fragment>
            <Head titulo="Todos Licitantes do Município de Macuco" />
            <Header />
            <Container>
                <ListaLicitantes />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaLicitantesScreen;